import fanaticsTheme from './fanatics';
import foxTheme from './fox';
import oddscheckerTheme from './oddschecker';

const themes: Record<string, string> = {
  fanatics: fanaticsTheme,
  fox: foxTheme,
  oddschecker: oddscheckerTheme
};

export default function (theme?: string): string {
  return (theme && themes[theme]) ?? oddscheckerTheme;
}
